import { semanticColorGroups as r, adjustColorGroup as o } from "./index37.mjs";
const b = (e) => {
  if (!r[0] || !r[1] || !r[2] || !r[3])
    return "";
  const t = Object.entries(
    o(e.oldBrandPrimary, r[0])
  ).map(([a, n]) => `${a}: ${n};`).join(`
`), i = Object.entries(
    o(e.oldTextPrimary, r[1])
  ).map(([a, n]) => `${a}: ${n};`).join(`
`), s = Object.entries(
    o(e.oldBackgroundPrimary, r[2])
  ).map(([a, n]) => `${a}: ${n};`).join(`
`), d = Object.entries(
    o(e.oldBackgroundHeader, r[3])
  ).map(([a, n]) => `${a}: ${n};`).join(`
`);
  return `
        ${[
    t,
    i,
    s,
    d
  ].join(`

`)}
    `;
};
export {
  b as getRootVarsByBrandColors
};
